/**
 * @author jzhu
 * @date 2020-09-21
 * @desc 活动话题
 */
import React from "react";
import { connect } from "dva";
import moment from "moment";
import { WizTableForm } from "../../../common";
import { component_tool, framework_tool, utils_tool } from "@/tool";
let { WizContainer, modelUtils } = framework_tool;
let {
  WizCard,
  WizDescriptions,
  WizSearchBar,
  WizButton,
  WizDataTable,
  WizModal,
} = component_tool;
let { Session } = utils_tool;

const getParamRecord = (history) => {
  let record = null;
  if (
    history.location &&
    history.location.pathname === "/interact/activity/activityTopic"
  ) {
    if (history.location.record) {
      record = history.location.record;
      Session.set("activityTopic", record);
    } else {
      record = Session.get("activityTopic") || {};
    }
  }
  return record;
};
const formatterDate = (val) => {
  return val ? moment(val).format("YYYY-MM-DD HH:mm") : "";
};

class ActivityTopic extends WizContainer {
  componentName = "ActivityTopic";

  constructor(props) {
    super(props);
    let { history } = props;
    let record = getParamRecord(history);
    this.state = {
      record,
      visible: false,
      search: {},
      timestamp: new Date().getTime(),
    };
  }

  _componentDidMount() {
    this._getTopicList();
  }

  _getTopicList = (values = {}) => {
    let { record } = this.state;
    if (record.id) {
      this.doAction({
        path: "activityTopic/list",
        payload: {
          key: "activityTopicList",
          apiParams: {
            activityId: record.id,
            ...values,
          },
        },
      });
    }
  };

  _onChangeState = (apiParams, state) => {
    let { record } = this.state;
    if (record.id) {
      WizModal.confirm({
        title: "注意",
        content: `您确定要${state === 0 ? "打开" : "关闭"}该活动话题吗？`,
        onOk: () => {
          this.doAction({
            path: "activityTopic/enable",
            payload: {
              key: "activityTopicEnable",
              apiParams,
            },
          });
        },
        onCancel() {},
      });
    }
  };

  propsAndStateOnChange = {
    create: this._createOnChange.bind(this),
    enable: this._enableOnChange.bind(this),
  };

  _createOnChange(nextProps, nextState) {
    if (nextProps.create.code === 1) {
      wizNotice.success("保存成功");
      this._getTopicList(this.state.search);
    } else {
      wizNotice.error(
        (nextProps.create && nextProps.create.msg) || "操作失败,请稍后尝试"
      );
    }
    return true;
  }

  _enableOnChange(nextProps, nextState) {
    if (nextProps.enable.code === 1) {
      wizNotice.success("操作成功");
      this._getTopicList(this.state.search);
    } else {
      wizNotice.error(
        (nextProps.enable && nextProps.enable.msg) || "操作失败,请稍后尝试"
      );
    }
    return true;
  }

  _columns = () => {
    let activityColumns = [
      {
        title: "活动名称",
        name: "name",
        dataIndex: "name",
        describeItem: {},
      },
      {
        title: "活动时间",
        name: "activityTime",
        dataIndex: "activityTime",
        describeItem: {
          render: (text, record) => {
            let { startTime, endTime } = record;
            let value =
              formatterDate(startTime) + " ~ " + formatterDate(endTime);
            return <div>{value}</div>;
          },
        },
      },
      {
        title: "主办方",
        name: "sponsor",
        dataIndex: "sponsor",
        describeItem: {},
      },
      // {
      //   title: "是否需要报名",
      //   name: "apply",
      //   dataIndex: "apply",
      //   dict: [
      //     { code: 0, codeName: "否" },
      //     { code: 1, codeName: "是" },
      //   ],
      //   describeItem: {},
      // },
    ];
    let listColumns = [
      {
        title: "话题名称",
        name: "title",
        dataIndex: "title",
        searchItem: {},
        tableItem: {
          render: (text, record) => (
            <WizDataTable.Oper>
              <WizButton
                tooltip={text}
                onClick={() =>
                  this.jumpPage &&
                  this.jumpPage(
                    "push",
                    "/interact/activity/activityTopic/topicLook",
                    record
                  )
                }
              >
                {text}
              </WizButton>
            </WizDataTable.Oper>
          ),
        },
      },
      {
        title: "有效日期",
        name: "date",
        dataIndex: "date",
        tableItem: {
          render: (text, record) => {
            let { start, end } = record;
            let value = start + " ~ " + end;
            return <div>{value}</div>;
          },
        },
      },
      {
        title: "话题状态",
        name: "topicState",
        dataIndex: "topicState",
        dict: [
          { code: 1, codeName: "有效" },
          { code: 0, codeName: "无效" },
        ],
        tableItem: {},
      },
      {
        title: "关联状态",
        name: "state",
        dataIndex: "state",
        dict: [
          { code: 1, codeName: "打开" },
          { code: 0, codeName: "关闭" },
        ],
        searchItem: {
          type: "select",
        },
        tableItem: {},
      },
      {
        title: "操作",
        tableItem: {
          width: 50,
          render: (text, record) => {
            let btn = record.state === 0 ? "打开" : "关闭";
            let apiParams = {
              id: record.id,
              state: record.state === 0 ? 1 : 0,
            };
            return (
              <WizDataTable.Oper>
                <WizButton
                  onClick={() => this._onChangeState(apiParams, record.state)}
                >
                  {btn}
                </WizButton>
              </WizDataTable.Oper>
            );
          },
        },
      },
    ];
    let topicColumns = [
      {
        title: "话题名称",
        name: "title",
        dataIndex: "title",
        searchItem: {},
        tableItem: {},
      },
      {
        title: "有效日期",
        name: "date",
        dataIndex: "date",
        tableItem: {
          render: (text, record) => {
            let { start, end } = record;
            let value = start + " ~ " + end;
            return <div>{value}</div>;
          },
        },
      },
    ];
    return { activityColumns, listColumns, topicColumns };
  };

  _onRowDisabled = (record) => {
    let disabled = false;
    let topicId = record.id;
    let { list } = this.props;
    list.data &&
      list.data.length &&
      list.data.forEach((item) => {
        if (item.topicId === topicId) {
          disabled = true;
          return;
        }
      });
    return disabled;
  };

  _render() {
    let { record, visible, timestamp } = this.state;
    let { list } = this.props;
    let { activityColumns, listColumns, topicColumns } = this._columns();
    let descriptionsProps = {
      record,
      columns: activityColumns,
      column: 2,
    };
    let searchBarProps = {
      type: "grid",
      columns: listColumns,
      onSearch: (values) => {
        this.setState({ search: values });
        this._getTopicList(values);
      },
      collapse: false
    };
    let dataTableProps = {
      loading: this.props.activityTopicLoading,
      columns: listColumns,
      rowKey: "id",
      dataItems: {},
      dataSource: list.data || [],
      showNum: false,
      isScroll: true,
      pagination: false,
    };
    let tableFormProps = {
      key: "key_" + timestamp,
      visible,
      cols: {
        xs: 12,
        md: 12,
        xl: 12,
      },
      showSelect: false,
      columns: topicColumns,
      tableApi: {
        path: "topic/basePageByDataPermission",
        apiParams: { state: 1 },
      },
      rowName: "title",
      selectType: "radio",
      tableProps: {
        needOnRowSelect: (record) => {
          let disabled = this._onRowDisabled(record);
          return !disabled;
        },
        rowSelection: {
          getCheckboxProps: (record) => {
            let disabled = this._onRowDisabled(record);
            return { disabled };
          },
        },
      },
      renderValue: () => {
        return (
          <div className="btns-toolbar-group">
            <WizButton
              title="添加"
              icon="plus"
              type="primary"
              onClick={() =>
                this.setState({
                  visible: true,
                  timestamp: new Date().getTime(),
                })
              }
            >
              {"添加"}
            </WizButton>
          </div>
        );
      },
      onSubmit: (values) => {
        this.doAction({
          path: "activityTopic/create",
          payload: {
            key: "createActivityTopic",
            apiParams: {
              activityId: record.id,
              topicId: values.value,
              state: 1,
            },
          },
        });
        this.setState({ visible: false });
      },
      onCancel: () => this.setState({ visible: false }),
    };
    return (
      <>
        <WizCard title={"活动信息"}>
          <WizDescriptions {...descriptionsProps} />
        </WizCard>
        <WizCard icon="disconnect" title={"关联话题"}>
          <WizSearchBar {...searchBarProps} />
          <WizTableForm {...tableFormProps} />
          <WizDataTable {...dataTableProps} />
        </WizCard>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activityTopic } = state;
  const list = modelUtils.getModelEntity(activityTopic, "activityTopicList");
  const create = modelUtils.getModelEntity(
    activityTopic,
    "createActivityTopic"
  );
  const enable = modelUtils.getModelEntity(
    activityTopic,
    "activityTopicEnable"
  );
  const load = modelUtils.getLoadingState(state, "activityTopic");
  return {
    list,
    create,
    enable,
    ...load,
  };
};

export default connect(mapStateToProps)(ActivityTopic);
